import { JobFilterUI } from "../components/filters/ui";
import { JobSearchBar } from "../components/job-search-bar/job-search-bar";
import { SELF_APPLY_USER_TYPE_ENUM } from "../../types/self-apply-user-type";
import { CandidateSelfApplyHeader } from "../../candidate/components/candidate-self-apply-header";
import { ConnectedCandidateJobList } from "./connect-job-list";
import { BaseJobListPage } from "modules/self-apply/pages/job-list-page";

// Candidate Specific Job List Page
export const CandidateJobListPage = () => {
  return (
    <BaseJobListPage.Container
      selfApplyUserType={SELF_APPLY_USER_TYPE_ENUM.CANDIDATE}
    >
      <BaseJobListPage.Header>
        <CandidateSelfApplyHeader />
      </BaseJobListPage.Header>
      <BaseJobListPage.Content>
        <JobSearchBar />
        <ConnectedCandidateJobList />
      </BaseJobListPage.Content>
      <BaseJobListPage.Filters>
        <JobFilterUI />
      </BaseJobListPage.Filters>
    </BaseJobListPage.Container>
  );
};
